<template>
    <div>
        <div class="breadcrumb-layout" v-if="showTitleFalg">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>业务参数</el-breadcrumb-item>
            </el-breadcrumb>
        </div>

        <div v-if="groupList == null || groupList.length <= 0">
            <span>暂无业务参数需要维护</span>
        </div>
        <div v-else>
            <div class="tab-container small base">
                <div class="tabs-nav">
                    <ul class="head">
                        <li :class="{'current': group.code == checkTab}" class="head-item" v-for="group in groupList" @click="handleTabClick(group.code)">
                            <span>{{group.name}}</span>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="setting-info" v-if="bizParamMap != null && bizParamMap[checkTab] != null && bizParamMap[checkTab].length > 0">
                <div v-if="checkTab == 'asset.biz.setting'">
                    <div v-if="inputValue && autoCalcParam != null && autoCalcParamDate != null">
                        <div class="setting-row">
                            <div class="setting-value" v-if="autoCalcParam.merchantBizParam == null">
                                <swb-pattern-input class="inline-block" :viewMode="autoCalcParam.merchantRealFlag" :pattern="autoCalcParam.pattern" :initValue="autoCalcParam.defValue" :inputType="autoCalcParam.inputType" :valueType="autoCalcParam.typeName" :ref="autoCalcParam.code"></swb-pattern-input>
                                <span class="inline-block ml10">描述：{{autoCalcParam.desc || '无'}}</span>
                            </div>
                            <div class="setting-value" v-else>
                                <swb-pattern-input class="inline-block" :viewMode="autoCalcParam.merchantRealFlag" :pattern="autoCalcParam.pattern" :initValue="autoCalcParam.merchantBizParam.value" :inputType="autoCalcParam.merchantBizParam.inputType" :valueType="autoCalcParam.merchantBizParam.typeName" :ref="autoCalcParam.code"></swb-pattern-input>
                                <span class="inline-block ml10">描述：{{autoCalcParam.desc || '无'}}</span>
                            </div>
                        </div>
                        <div class="setting-row" style="overflow: visible;">
                            <div class="setting-value" v-if="autoCalcParamDate.merchantBizParam == null">
                                <swb-pattern-input class="inline-block" :viewMode="autoCalcParamDate.merchantRealFlag" :pattern="autoCalcParamDate.pattern" :initValue="autoCalcParamDate.defValue" :inputType="autoCalcParamDate.inputType" :valueType="autoCalcParamDate.typeName" :ref="autoCalcParamDate.code"></swb-pattern-input>
                                <span class="inline-block ml10">描述：
                                    <swb-pattern-input class="inline-block" :viewMode="true" :pattern="autoCalcParamDate.pattern" :inputType="autoCalcParamDate.inputType" :valueType="autoCalcParamDate.valueType" :initValue="autoCalcParamDate.value"></swb-pattern-input>
                                </span>
                            </div>
                            <div class="setting-value" v-else>
                                <swb-pattern-input class="inline-block" :viewMode="autoCalcParamDate.merchantRealFlag" :pattern="autoCalcParamDate.pattern" :initValue="autoCalcParamDate.merchantBizParam.value" :inputType="autoCalcParamDate.merchantBizParam.inputType" :valueType="autoCalcParamDate.merchantBizParam.typeName" :ref="autoCalcParamDate.code"></swb-pattern-input>
                                <span class="inline-block ml10">描述：
                                    <swb-pattern-input class="inline-block" :viewMode="true" :pattern="autoCalcParamDate.pattern" :inputType="autoCalcParamDate.merchantBizParam.inputType" :valueType="autoCalcParamDate.merchantBizParam.valueType" :initValue="autoCalcParamDate.merchantBizParam.value"></swb-pattern-input>
                                </span>
                            </div>
                        </div>
                    </div>
                    <div class="setting-row" v-if="bizParam.code != 'auto.calc.asset.worth.values.monthly' && bizParam.code != 'auto.calc.asset.worth.values.at.date'" v-for="bizParam in bizParamMap[checkTab]">
                        <div class="setting-value" v-if="bizParam.merchantBizParam == null">
                            <swb-pattern-input class="inline-block" :viewMode="bizParam.merchantRealFlag" :pattern="bizParam.pattern" :initValue="bizParam.defValue" :inputType="bizParam.inputType" :valueType="bizParam.typeName" :ref="bizParam.code"></swb-pattern-input>
                            <span class="inline-block ml10">描述：{{bizParam.desc || '无'}}</span>
                            <span class="inline-block font-red ml10" v-if="bizParam.code == 'asset.definition.create.alter.need.audit'">注意：开启后，不能通过采购合同等业务创建资产定义！</span>
                        </div>
                        <div class="setting-value" v-else>
                            <swb-pattern-input class="inline-block" :viewMode="bizParam.merchantRealFlag" :pattern="bizParam.pattern" :initValue="bizParam.merchantBizParam.value" :inputType="bizParam.merchantBizParam.inputType" :valueType="bizParam.merchantBizParam.typeName" :ref="bizParam.code"></swb-pattern-input>
                            <span class="inline-block ml10">描述：{{bizParam.desc || '无'}}</span>
                            <span class="inline-block font-red ml10" v-if="bizParam.code == 'asset.definition.create.alter.need.audit'">注意：开启后，不能通过采购合同等业务创建资产定义！</span>
                        </div>
                    </div>
                </div>
                <div class="setting-row" v-for="bizParam in bizParamMap[checkTab]" v-else>
                    <div class="setting-value" v-if="bizParam.merchantBizParam == null">
                        <swb-pattern-input class="inline-block" :viewMode="bizParam.merchantRealFlag" :pattern="bizParam.pattern" :initValue="bizParam.defValue" :inputType="bizParam.inputType" :valueType="bizParam.typeName" :ref="bizParam.code"></swb-pattern-input>
                        <span class="inline-block ml10">描述：{{bizParam.desc || '无'}}</span>
                    </div>
                    <div class="setting-value" v-else>
                        <swb-pattern-input class="inline-block" :viewMode="bizParam.merchantRealFlag" :pattern="bizParam.pattern" :initValue="bizParam.merchantBizParam.value" :inputType="bizParam.merchantBizParam.inputType" :valueType="bizParam.merchantBizParam.typeName" :ref="bizParam.code"></swb-pattern-input>
                        <span class="inline-block ml10">描述：{{bizParam.desc || '无'}}</span>
                    </div>
                </div>
                <div class="form-toolbar">
                    <button class="swb-btn" @click="addMerchantBizParam()">保存</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-merchant-biz-param-list-new',
        avlScopes: 'retailer',
        desc: '业务参数列表(商户用)',
        props: {
            groupCodeList: {
                default: []
            }
        },
        data: function () {
            return {
                showTitleFalg: true,
                bizParamGroupList: [],
                groupList: [],
                bizParamMap: {},
                checkTab: null,
                autoCalcParam: null,
                autoCalcParamDate: null,
                normalized: false,
                inputValue: false,
                finacFlag: false,
            }
        },
        created: function () {
            if(this.groupCodeList != null && this.groupCodeList.length > 0) {
                this.showTitleFalg = false;
            }
            //
            this.getBizParamGroupListByFilter();
        },
        methods: {
            getBizParamGroupListByFilter: function () {
                let self = this;
                let postData = {
                    codeList: this.groupCodeList,
                };
                merchtComnApi.getBizParamGroupList(postData, function (result) {
                    if(result.type == "info") {
                        self.bizParamGroupList = result.data;
                        self.makeGroupList();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            // 获取分组
            makeGroupList: function () {
                let groupList = [];
                let bizParamMap = {};
                let bizParamGroupList = this.bizParamGroupList || [];
                for(let i = 0; i < bizParamGroupList.length; i++) {
                    let bizParamGroup = bizParamGroupList[i];
                    let bizParamList = bizParamGroup.bizParamList || [];
                    if(bizParamList.length > 0) {
                        let group = {
                            code: bizParamGroup.code,
                            name: bizParamGroup.name
                        };
                        groupList.add(group);
                        //
                        bizParamMap[bizParamGroup.code] = bizParamList;
                    }
                }
                if(groupList.length > 0) {
                    this.groupList = Utils.merge([], groupList);
                    this.bizParamMap = Utils.merge({}, bizParamMap);
                    if(Utils.isNoB(this.checkTab)) {
                        this.checkTab = groupList[0].code;
                    }
                    //
                    let bizParamList = bizParamMap["asset.biz.setting"] || [];
                    for(let i = 0; i < bizParamList.length; i++) {
                        let bizParam = bizParamList[i];
                        if(bizParam.code == 'auto.calc.asset.worth.values.monthly') {
                            this.autoCalcParam = bizParam;
                        } else if(bizParam.code == 'auto.calc.asset.worth.values.at.date') {
                            this.autoCalcParamDate = bizParam;
                        } else if(bizParam.code == 'finac.mgmt.enabled') {
                            this.inputValue = Utils.isTrue(bizParam.merchantBizParam.value) ? true : false;
                            this.finacFlag = Utils.isTrue(bizParam.merchantBizParam.value);
                        }
                    }
                }
            },
            // 切换分组
            handleTabClick(val) {
                this.checkTab = Utils.merge(null, val);
            },
            // 保存业务参数
            addMerchantBizParam: function () {
                let self = this;
                let checkTab = self.checkTab;
                self.saveMerchantBizParam(checkTab, null);
            },
            saveMerchantBizParam: function (checkTab, compMethod) {
                let self = this;
                let bizParamMap = self.bizParamMap;
                let bizParamList = bizParamMap[checkTab] || [];
                let merchantBizParamList = [];
                //
                for(let i = 0; i < bizParamList.length; i++) {
                    let bizParam = bizParamList[i];
                    //
                    let value = null;
                    console.log(checkTab);
                    if(checkTab == 'asset.biz.setting') {
                        if(Utils.isTrue(self.inputValue) && (bizParam.code == 'auto.calc.asset.worth.values.at.date' || bizParam.code == 'auto.calc.asset.worth.values.monthly')) {
                            value = self.$refs[bizParam.code].getValue();
                            if(bizParam.code == 'auto.calc.asset.worth.values.at.date') {
                                if(!Utils.isNum(value) || value < -1) {
                                    MsgBox.warning("自动计算折旧、净值日期应为大于0的整数");
                                    return false;
                                }
                            }
                        } else if(bizParam.code == 'finac.mgmt.enabled') {
                            value = self.inputValue;
                        } else {
                            if(!(!Utils.isTrue(self.inputValue) && (bizParam.code == 'auto.calc.asset.worth.values.at.date' || bizParam.code == 'auto.calc.asset.worth.values.monthly'))) {
                                value = self.$refs[bizParam.code][0].getValue();
                            } else {
                                value = bizParam.defValue;
                            }
                        }
                    } else {
                        value = self.$refs[bizParam.code][0].getValue();
                    }
                    let merchantBizParam = {};
                    if(bizParam.merchantBizParam != null) {
                        merchantBizParam = bizParam.merchantBizParam;
                        merchantBizParam.value = value;
                    } else {
                        merchantBizParam.defId = bizParam.id;
                        merchantBizParam.code = bizParam.code;
                        merchantBizParam.groupCode = bizParam.groupCode;
                        merchantBizParam.typeName = bizParam.typeName;
                        merchantBizParam.value = value;
                        merchantBizParam.desc = bizParam.desc;
                    }
                    merchantBizParamList.push(merchantBizParam);
                }
                //
                if(!Utils.isNoB(merchantBizParamList) && merchantBizParamList.length > 0) {
                    //
                    let merchantBizParamInfo = {};
                    if(checkTab == 'asset.biz.setting') {
                        merchantBizParamInfo.checkTab = checkTab;
                        merchantBizParamInfo.compMethod = compMethod;
                        merchantBizParamInfo.merchantBizParamList = merchantBizParamList;
                        merchtComnApi.saveMerchantBizParams(merchantBizParamInfo, function (result) {
                            if(result.type == 'info') {
                                MsgBox.success("保存成功！");
                                self.getBizParamGroupListByFilter();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    } else {
                        //
                        merchantBizParamInfo.merchantBizParamList = merchantBizParamList;
                        merchtComnApi.saveMerchantBizParams(merchantBizParamInfo, function (result) {
                            if(result.type == 'info') {
                                MsgBox.success("保存成功！");
                                self.getBizParamGroupListByFilter();
                            } else {
                                MsgBox.warning(result.message);
                            }
                        });
                    }
                } else {
                    MsgBox.warning("没有需要设置的参数");
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/bizParam/MerchantBizParamListNew.vue